import axios from "../utils/request";
import * as api from "../api";
import defaultValue from "./default";

export function login(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.LOGIN, {
        params
      }).then(response => {
        resolve(response.data);
      }, err => {
        resolve(defaultValue.login);
      })
      .catch((error) => {
        resolve(defaultValue.login)
      })
  })
}
export function msgList(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.MSG_TOP_TEN, {
        params
      }).then(response => {
        resolve(response.data);
      }, err => {
        resolve(defaultValue.msgList);
      })
      .catch((error) => {
        resolve(defaultValue.msgList)
      })
  })
}

export function appList(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.SYS_APP_QUERY, {
        params
      }).then(response => {
        resolve(response.data);
      }, err => {
        // resolve(defaultValue.menuList);
        console.log(err)
      })
      .catch((error) => {
        // resolve(defaultValue.menuList)
      })
  })
}


export function menuList(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.SYS_MENU_LIST, params).then(response => {
        resolve(response);
      }, err => {
        reject(err)
      })
      .catch((error) => {
        resolve(defaultValue.menuList)
      })
  })
}

export function addmenu(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.SYS_MENU_ADD, params).then(response => {
        resolve(response);
      }, err => {
        reject(err)
      })
      .catch((error) => {
        resolve(defaultValue.menuList)
      })
  })
}

export function updatemenu(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.SYS_MENU_UPDATE, params).then(response => {
        resolve(response);
      }, err => {
        reject(err)
      })
      .catch((error) => {
        resolve(defaultValue.menuList)
      })
  })
}

export function resourceList(params) {
  return new Promise((resolve, reject) => {
    axios.get(api.SYS_RESOURCE_LIST, {
        params
      }).then(response => {
        resolve(response.data);
      }, err => {
        resolve(defaultValue.resource);
      })
      .catch((error) => {
        resolve(defaultValue.resource)
      })
  })
}

export function roleList(params) {
  return new Promise((resolve, reject) => {
    axios.get(api.SYS_MENU_LIST, {
        params
      }).then(response => {
        resolve(response.data);
      }, err => {
        resolve(defaultValue.roleList);
      })
      .catch((error) => {
        resolve(defaultValue.roleList)
      })
  })
}

export function roleModuleMappingList(id) {
  return new Promise((resolve, reject) => {
    axios.get(api.SYS_ROLE_RESOURCE + "?roleId=" + id).then(response => {
        resolve(response);
      }, err => {
        resolve(defaultValue.roleList);
      })
      .catch((error) => {
        resolve(defaultValue.roleList)
      })
  })
}

export function SetRoleMappingModule(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.SYS_SET_ROLE_RESOURCE, params).then(response => {
        resolve(response);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function userList(params) {
  const userList = {
    total: defaultValue.userList.total,
    records: defaultValue.userList.records.reverse()
  }
  return new Promise((resolve, reject) => {
    axios.get(api.SYS_USER_PAGE, {
        params
      }).then(response => {
        resolve(response);
      }, err => {
        resolve(userList);
      })
      .catch((error) => {
        resolve(userList)
      })
  })
}

export function userLockStatusChange(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.SYS_USER_SETLOCKOUT, params).then(response => {
        resolve(response);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export function hospatialRoleMappingList(id) {
  return new Promise((resolve, reject) => {
    axios.get(api.HOSPITAL_RolePermission + "?roleId=" + id).then(response => {
        resolve(response);
      }, err => {
        resolve(defaultValue.roleList);
      })
      .catch((error) => {
        resolve(defaultValue.roleList)
      })
  })
}
export function HospatialSetRoleMappingModule(params) {
  return new Promise((resolve, reject) => {
    axios.post(api.HOSPITAL_SetRolePermission, params).then(response => {
        resolve(response);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/services/sys.js